import {IncrementDecrementType} from "../types/IncrementDecrementType";

export const increment = ({ref}: IncrementDecrementType) => {
  if (ref.current){
    const currentValue = parseInt(ref.current.value, 10);
    const value = currentValue + 1 <= 50 ? currentValue + 1 : 50
    ref.current.value = `${value}`;
    return  `${value}`
  }
  return '1'
}
